import type { StateCreator } from "zustand";
import type { ResultOf } from "gql.tada";
import type { CALCULATION_DETAIL_FRAGMENT } from "../graphql/queries";

export type Calculation = ResultOf<typeof CALCULATION_DETAIL_FRAGMENT>;

export interface CalculationDetailSlice {
  calculation: Calculation | null;
  /**
   * Write the entity only when `calc.id === expectedId` AND the slice does not
   * already hold a different entity (navigation-race guard). Returns `true` if
   * the write landed; callers should gate success side-effects on that value.
   */
  setCalculation: (calc: Calculation, expectedId: string) => boolean;
  clearCalculation: () => void;
}

export const calculationDetailSlice: StateCreator<
  CalculationDetailSlice,
  [["zustand/immer", never]],
  [],
  CalculationDetailSlice
> = (set, get) => ({
  calculation: null,
  setCalculation: (calc, expectedId) => {
    if (calc.id !== expectedId) return false;
    const current = get().calculation;
    if (current && current.id !== expectedId) return false;
    set((s) => {
      s.calculation = calc;
    });
    return true;
  },
  clearCalculation: () =>
    set((s) => {
      s.calculation = null;
    }),
});
